/**
 * @flow
 * @relayHash c631423c625b02718e4edba2db078a54
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateGLAccountMappingInput = {|
  mappingKey: string,
  glAccountId: string,
|};
export type UpdateGLAccountMappingMutationVariables = {|
  input: UpdateGLAccountMappingInput
|};
export type UpdateGLAccountMappingMutationResponse = {|
  +updateGLAccountMapping: {|
    +glAccountMapping: {|
      +id: string,
      +mappingKey: string,
      +account: {|
        +id: string,
        +accountNumber: string,
        +name: string,
      |},
    |}
  |}
|};
export type UpdateGLAccountMappingMutation = {|
  variables: UpdateGLAccountMappingMutationVariables,
  response: UpdateGLAccountMappingMutationResponse,
|};
*/


/*
mutation UpdateGLAccountMappingMutation(
  $input: UpdateGLAccountMappingInput!
) {
  updateGLAccountMapping(input: $input) {
    glAccountMapping {
      id
      mappingKey
      account {
        id
        accountNumber
        name
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateGLAccountMappingInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateGLAccountMapping",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateGLAccountMappingPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "glAccountMapping",
        "storageKey": null,
        "args": null,
        "concreteType": "GLAccountMapping",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "mappingKey",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "account",
            "storageKey": null,
            "args": null,
            "concreteType": "GLAccount",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "accountNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateGLAccountMappingMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateGLAccountMappingMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateGLAccountMappingMutation",
    "id": null,
    "text": "mutation UpdateGLAccountMappingMutation(\n  $input: UpdateGLAccountMappingInput!\n) {\n  updateGLAccountMapping(input: $input) {\n    glAccountMapping {\n      id\n      mappingKey\n      account {\n        id\n        accountNumber\n        name\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3b31fe661cffcef20264d2d71c937b68';
module.exports = node;
